import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { combineLatest, Observable, of, tap } from "rxjs";
import { map, pluck, switchMap } from "rxjs/operators";
import { Resource } from "src/app/models/resource.model";
import { environment } from "src/environments/environment";
import {
  LoadingState,
  switchMapWithLoading,
} from "../../interfaces/loading-state";

@Injectable()
export class ResourcesService {
  constructor(protected http: HttpClient) {}

  partnerResourcesPath = environment.ws + "/partner-resources";

  getAllResources(): Observable<Resource[]> {
    return this.http
      .get(this.partnerResourcesPath, {
        responseType: "json",
        headers: {
          version: "2",
        },
      })
      .pipe(
        pluck("data"),
        map((resources: Resource[]) => {
          return resources.map((resource) =>
            new Resource().deserialize(resource)
          );
        })
      );
  }

  get_resource(resource_id: string): Observable<Resource> {
    const response = this.http.get(
      `${this.partnerResourcesPath}/${resource_id}`,
      {
        responseType: "json",
        headers: {
          version: "2",
        },
      }
    );
    return response.pipe(
      pluck("data"),
      map((resource: Resource) => {
        return new Resource().deserialize(resource);
      }),
      tap((resource) => {
        console.log("Resource fetched");
      })
    );
  }
  getResources(resource_ids: string[]): Observable<Resource[]>;
  getResources(
    resource_ids: string[],
    loadingState: true
  ): Observable<LoadingState<Resource[]>>;
  getResources(
    resource_ids: string[],
    loadingState = false
  ): Observable<Resource[]> | Observable<LoadingState<Resource[]>> {
    const fetchResources = (ids: any) => {
      return combineLatest([
        ...ids.map((id) => this.get_resource(id)),
      ]) as Observable<Resource[]>;
    };
    const resources$ = of(resource_ids).pipe<
      LoadingState<Resource[]> | Resource[]
    >(
      loadingState
        ? switchMapWithLoading(fetchResources)
        : switchMap(fetchResources)
    );
    if (loadingState) {
      return resources$ as Observable<LoadingState<Resource[]>>;
    }
    return resources$ as Observable<Resource[]>;
  }

  updateResource(resource: Resource, logo?: File) {
    const formData = new FormData();

    for (const key of Object.keys(resource.serialize())) {
      const value = resource[key];

      // This was seperated because leaderboard preferences is a nested object, and it needs to be stringified for a multipart request
      if (
        key === "leaderboard_preferences" &&
        typeof value === "object" &&
        value !== null
      ) {
        formData.set(key, JSON.stringify(value));
        const jsonString = JSON.stringify(value);
        console.log(
          "Sending leaderboard_preferences:",
          value,
          "as JSON:",
          jsonString
        );
      } else {
        formData.set(key, value);
      }
    }
    if (logo) {
      formData.set("logo", logo);
    }

    const data = this.http.put(this.partnerResourcesPath, formData, {
      responseType: "json",
      headers: {
        version: "2",
      },
    });

    return data;
  }
}
